// A hook that takes a current value string, and returns the same value. But, when the value
// changes, instead it returns the previous value string that was passed to it, before the value changed.
import { useEffect, useRef } from 'react';

export default function usePreviousValue<T>(value: T): T {
  const ref = useRef<T>(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}
